<template>
  <div class="fare-family-service-container">
    <span class="is-size-7 has-text-grey is-capitalized">{{ serviceDescriptionDisplay }}</span>
    <b-icon :icon="statusIcon.name" :type="statusIcon.type" pack="mdi" class="is-pulled-right" />
  </div>
</template>

<script>


    import bookingMixin from "@/mixins/bookingMixin";

    export default {
      name: 'FareFamilyService',
      mixins: [bookingMixin],
      props: {
        service: Object,
      },
      components: {
      },
      data: function () {
          return {
            multiline: true,
        }
      },
      computed: {
        statusLabel: function () {
          return this.service.status;
        },
        serviceDescriptionDisplay: function () {
          return this.service.description.toLowerCase();
        },
        statusIcon: function () {
          if (this.service.status === 'included') {
            return {'name':'check', 'type': 'is-success'};
          } else if (this.service.status === 'chargeable') {
            return {'name':'currency-usd', 'type': 'is-info'};
          } 
          return {'name':'help', 'type': 'is-dark'};
        },
      },
  }

</script>

<style lang="scss" scoped>

</style>
